// export default () => ({
// })

export default () => ({
    inputs: [],
    inputsPaginatedData: null,
    input: null,
    isLoading: false,
    isLoadingInputsUnplaceData: false,
    inputsUnplacedData: null
})